// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"24":"e15ccb5b","265":"d6631dea","310":"4892e9d1","420":"0207aa82","607":"b24ddbd1","807":"60fc9ad1","826":"4ebb60ab"}[chunkId] + ".css";
};